'use client'
import dynamic from 'next/dynamic'

const ToastViewport = dynamic(() => import('./ToastViewport'), { ssr: false })

interface ToastProviderProps {
  children: React.ReactNode
}

export default function NotificationProvider({ children }: ToastProviderProps) {
  return (
    <>
      {children}
      <ToastViewport />
    </>
  )
}
